export default "/fonts/vendor/summernote/dist/summernote.woff?08c343ff91f188dfc1a7ae4ad1126b59";